module.exports = __webpack_public_path__ + "media/images/common/rocket-3604bf5c9aeb9234df4d15bc4ac1f80a.png";